"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ToAsset = function ToAsset(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 41.61 24",
    width: "41.61",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m24.8 1.74v5.45h-5.45v-5.45zm1.74-1.74h-8.93v8.93h8.93z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m39.87 1.74v5.45h-5.45v-5.45zm1.74-1.74h-8.93v8.93h8.93z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m24.84 16.81v5.45h-5.45v-5.45zm1.7-1.74h-8.93v8.93h8.93z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m28.57 0h2.09v8.93h-2.09z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m25.23 12.02h16.38v2.01h-16.38z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m17.61 10h4.23v2.01h-4.23z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m29.09 17.02h6.55v2.01h-6.55z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m39.52 17.02v4.89h-6.88v2.09h8.97v-.02-2.07-4.89z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m.9 11.74h10.71l-1.61-1.64a.91.91 0 0 1 1.28-1.28l3.14 3.18a.9.9 0 0 1 0 1.27l-3.18 3.18a.91.91 0 0 1 -1.28 0 .9.9 0 0 1 0-1.27l1.65-1.65h-10.71a.9.9 0 1 1 0-1.8z"
  })));
};

var _default = ToAsset;
exports["default"] = _default;